import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { SOURCE_CATALOGUE } from '../../store/constants';
import { addSingleProductToCart } from './addSingleProductToCart';
import { UpdateProductOptions } from '../../store/products/actionsCart';
import { singleUpdateToCart } from './singleUpdateToCart';

export const useAddToCart = (callback: () => void) => {
    const { t } = useTranslation();
    const dispatchRedux = useDispatch();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        addToCart: (options: UpdateProductOptions, performChecks: boolean) => {
            const apiCallback = () => {
                return addSingleProductToCart({
                    productId: options.id,
                    body: {
                        usageCondition:
                            typeof options.price?.usageLimit === 'number' &&
                            typeof options.price?.termLimit === 'number' &&
                            options.price?.lendingModel
                                ? {
                                      usageLimit: options.price.usageLimit,
                                      termLimit: options.price.termLimit,
                                      lendingModel: options.price.lendingModel
                                  }
                                : null,
                        subscriptionPeriodType: options.targetSubscriptionPeriodType
                    },
                    params: {
                        performChecks
                    }
                });
            };

            return singleUpdateToCart({
                dispatch: dispatchRedux,
                setLoading,
                performChecks,
                source: SOURCE_CATALOGUE,
                notificationMessage: t('notifications.getMessageFromActionCart.add', { productTitle: options.title }),
                apiCallback,
                callback
            });
        }
    };
};
